import { BehaviorEnum, Properties } from "@/services/posts/types";
import { CSS } from "@/services/styles/types";
import { MediaType } from "@/services/files/types";

export interface FixedHtmlProperties extends Properties {
    showTime: number;
    contentTemplateId: string;
    contentTemplate: string;
    data: fixedHtmlData[];
}

export interface ComponentData {
    data: fixedHtmlData[];
}

export interface fixedHtmlData {
    [key: string]: any;
    id: string;
    text: string;
    src: string;
    allowedMedia: MediaType[];
    selectedMediaType: MediaType;
    toolbar: string;
    preventOverflow: string;
    adjustOnly: string;
    behavior: BehaviorEnum;
    allowedResizeBehaviors: string;
    position: MediaDimensionsProperties;
    fontSizes: string;
    qrCodeValue: string;
    qrCodeSize: string;
    qrCodeQuiteZone: string;
    macros: Macros;
}

export interface Macros {
    type: MacrosTypeEnum;
    countIn: MacrosCountInEnum;
    date: string;
    time: string;
    macrosOptions: MacrosOptions;
}

export interface MacrosOptions {
    type: boolean;
    countIn: boolean;
}

export enum MacrosTypeEnum {
    countUp = "countup",
    countDown = "countdown"
}

export enum MacrosCountInEnum {
    days = "days",
    daysWithTime = "dayswithtime"
}

export interface fileUploadStages {
    fileIsUploading: boolean;
    mediaId: string;
    failedUploading: boolean;
}

export interface fixedHtmlCSS extends CSS {
    wrapper: string,
}

export interface DataVsIdDuration {
    id: string,
    duration: number
}

export interface MediaDimensionsProperties {
    id: string,
    x: number,
    y: number,
    editorX: number,
    editorY: number,
    cropSizeWidth: number,
    cropSizeHeight: number,
    factor: number,
    channelWidth: number,
    channelHeight: number,
    imgWidth: number, // Width of the image, maintained for backward compatibility with the old image component
    imgHeight: number, // Height of the image, maintained for backward compatibility with the old image component
    videoWidth: number,
    videoHeight: number
}

export interface ContainerDimensions {
    width: number,
    height: number
}
